import clsx from 'clsx';
import StatusIcon from 'core/modules/atoms/StatusIcon/StatusIcon';
import PropTypes from 'prop-types';
import React from 'react';
import useInputPointsNumericScale from './useInputPointsNumericScale';

const InputPointsNumericScale = ({
  onChange,
  placeholder = '0',
  type = 'text',
  disabled = false,
  referer,
  size = 'default',
  isScoreReadOnly,
  max = 10,
  min,
  showDotted = false,
  isLate = false,
  colorsPoints,
  changeError,
  numberDecimals = 2,
  ...props
}) => {
  const { value, hasError, onChangeText, onFocus, onBlur, statusColor, t } = useInputPointsNumericScale({
    props,
    max,
    min,
    onChange,
    colorsPoints,
    changeError,
    numberDecimals,
  });

  return (
    <div className={clsx('input-points', `input-points--status-${statusColor}`, { 'input-points--read-only': isScoreReadOnly }, `input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container', { 'has-error': hasError }, { 'input-points__input-container--dotted': showDotted })}>
        <input
          className={clsx('input-points__input', { 'input-points__input--disabled': disabled })}
          type={type}
          placeholder={placeholder}
          onChange={onChangeText}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          ref={referer}
          readOnly={isScoreReadOnly}
          max={max}
          min={min}
          value={value}
        />
        {isLate && (
          <div className="input-points__late">
            <StatusIcon iconName="exclamation-circle" label={t('lesson:Delivered late')} shouldShowTooltip />
          </div>
        )}
        <label className="input-points__points-total">/{max}</label>
      </div>
    </div>
  );
};

InputPointsNumericScale.propTypes = {
  changeError: PropTypes.func,
  colorsPoints: PropTypes.bool,
  disabled: PropTypes.bool,
  isLate: PropTypes.bool,
  isScoreReadOnly: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  numberDecimals: PropTypes.oneOf([0, 1, 2, 3]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  showDotted: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  referer: PropTypes.object,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InputPointsNumericScale;
